import {
    SET_MAINTENANCE_DATA,
    SET_CAUTIONS_DATA,
    SET_COMPONENTTRACKING_DATA,
    SET_COMPONENTTRACKING_FILTER,
    SET_SELECTEDMR_DATA
} from './types';

const setMaintenanceData = (maintenanceData: any) => ({
    type: SET_MAINTENANCE_DATA,
    maintenanceData
});

const setCautionsData = (cautionsData: any) => ({
    type: SET_CAUTIONS_DATA,
    cautionsData
});

const setComponentTrackingData = (componentTrackingData: any) => ({
    type: SET_COMPONENTTRACKING_DATA,
    componentTrackingData
});
const setComponentTrackingFilter = (componentTrackingfilter: any) => ({
    type: SET_COMPONENTTRACKING_FILTER,
    componentTrackingfilter
});
const setSelectedMRData = (selectedMRdata: any[]) => ({
    type: SET_SELECTEDMR_DATA,
    selectedMRdata
});
export { setMaintenanceData, setCautionsData, setComponentTrackingData, setComponentTrackingFilter, setSelectedMRData };
